export type Frame = {
  id: string;
  label: string;
  w: number;
  h: number;
  hint: string;
};

export const FRAMES: Frame[] = [
  { id: "1:1", label: "Carré : 1080×1080", w: 1080, h: 1080, hint: "Fil Instagram et Facebook" },
  { id: "4:5", label: "Portrait : 1080×1350", w: 1080, h: 1350, hint: "Fil Instagram" },
  { id: "1.91:1", label: "Paysage : 1200×630", w: 1200, h: 630, hint: "Fil Facebook" },
  { id: "9:16", label: "Story : 1080×1920", w: 1080, h: 1920, hint: "Stories et Reels" },
];

export const MEDIA_RULES = [
  "Photos : JPEG, PNG ou WebP · 8 Mo · 1080 px de côté conseillés.",
  "Vidéos : MP4 ou MOV · 100 Mo · 60 s pour le fil, 1080×1920 pour Stories et Reels.",
  "Si le cadre ne colle pas, on recadre, on pivote et on déplace pour vous.",
];

export function needsCrop(nw: number, nh: number, frame: Frame): boolean {
  if (nw < 600 || nh < 600) return true;
  const got = nw / nh;
  const want = frame.w / frame.h;
  return Math.abs(got - want) / want > 0.03;
}
